// src/components/Icon.jsx
import React from "react";
import * as Icons from "./icons";

const IconReusable = ({
  name,
  size = 24,
  color = "currentColor",
  width,
  height,
  ...rest
}) => {
  const SvgIcon = Icons[name];
  if (!SvgIcon) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <SvgIcon
      width={width || size}
      height={height || size}
      fill={color}
      // stroke={color}
      {...rest}
    />
  );
};

export default IconReusable;
